import React from "react";
import { UI_TAG } from "oolib/dist/v2/components/Typo2";
import { colors2 } from "oolib";
import { CONFIDENCE_DOTS } from "../constants";

export function ConfidenceIndicator({ confidence, summary }) {
  if (!confidence) return null;
  const color = confidence >= 4 ? "#3BA974" : confidence >= 3 ? "#F8BC3B" : "#E92519";
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
      <UI_TAG style={{ color, letterSpacing: 2 }}>
        {CONFIDENCE_DOTS[confidence] || CONFIDENCE_DOTS[1]}
      </UI_TAG>
      {summary && <UI_TAG style={{ color: colors2.grey40 }}>{summary}</UI_TAG>}
    </div>
  );
}
